export default __webpack_public_path__ + "eb6edc3979c854b8a687a8b973dda56a.ttf";